import { Amplify, type ResourcesConfig } from "aws-amplify";
import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import type { NavigationGuard } from "vue-router";

const clientId = (import.meta.env.VITE_FARM_ENGAGE_CLIENT_ID_APP ??
	import.meta.env.VITE_FARM_ENGAGE_CLIENT_ID) as string;
const clientSecret = (import.meta.env.VITE_FARM_ENGAGE_CLIENT_SECRET_APP ??
	import.meta.env.VITE_FARM_ENGAGE_CLIENT_SECRET) as string;
const baseAuthUrl = (import.meta.env.VITE_FARM_ENGAGE_AUTH_URL_APP ??
	import.meta.env.VITE_FARM_ENGAGE_AUTH_URL) as string;
const apiUrl = (import.meta.env.VITE_FARM_ENGAGE_API_URL_APP ??
	import.meta.env.VITE_FARM_ENGAGE_API_URL) as string;
const FE_ACCESS_TOKEN_KEY = "farmengage_access_token";
const FE_REFRESH_TOKEN_KEY = "farmengage_refresh_token";

let accessToken = sessionStorage.getItem(FE_ACCESS_TOKEN_KEY) ?? "";
let refreshToken = sessionStorage.getItem(FE_REFRESH_TOKEN_KEY) ?? "";

function persistFarmEngageTokens(access: string, refresh: string) {
	accessToken = access;
	refreshToken = refresh;
	sessionStorage.setItem(FE_ACCESS_TOKEN_KEY, access);
	sessionStorage.setItem(FE_REFRESH_TOKEN_KEY, refresh);
}

export function isAuthenticated() {
	return (
		(accessToken || sessionStorage.getItem(FE_ACCESS_TOKEN_KEY) || "") !==
		""
	);
}

export function getFarmEngageToken() {
	return accessToken || sessionStorage.getItem(FE_ACCESS_TOKEN_KEY) || "";
}

export function getFarmEngageRefreshToken() {
	return refreshToken || sessionStorage.getItem(FE_REFRESH_TOKEN_KEY) || "";
}
export async function authenticate(code?: string) {
	const params = new URLSearchParams(window.location.search);
	const authCode = code ?? params.get("code");
	if (!authCode) throw new Error("Missing code in query string");

	const body = new URLSearchParams();
	body.set("grant_type", "authorization_code");
	body.set("code", authCode);
	body.set("client_id", clientId);
	const basic = btoa(`${clientId}:${clientSecret}`);

	const res = await fetch(baseAuthUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
			Authorization: `Basic ${basic}`,
		},
		body: body.toString(),
	});

	const text = await res.text();

	// remove code from URL
	const url = new URL(window.location.href);
	url.searchParams.delete("code");
	window.history.replaceState({}, document.title, url.toString());
	if (!res.ok) {
		throw new Error(`Authentication failed: ${res.status} ${text}`);
	}

	const data = JSON.parse(text) as {
		access_token: string;
		refresh_token: string;
	};

	persistFarmEngageTokens(data.access_token, data.refresh_token);
	return data;
}

export function configureAWS(config: ResourcesConfig) {
	Amplify.configure(config);
}

export function signOut() {
	sessionStorage.removeItem(FE_ACCESS_TOKEN_KEY);
	sessionStorage.removeItem(FE_REFRESH_TOKEN_KEY);
	accessToken = "";
	refreshToken = "";
}
export function startFarmEngageAuthFlow() {
	if (Capacitor.getPlatform() === "web") {
		window.location.replace(apiUrl);
		return;
	}
	void Browser.open({
		url: apiUrl,
	});
}
export function farmEngageAuthGuard() {
	startFarmEngageAuthFlow();
}
export const farmEngageImportAuthGuard: NavigationGuard = async () => {
	if (isAuthenticated()) return true;
	startFarmEngageAuthFlow();
	return false;
};
